import I18n from 'i18n-js/index.js.erb';
import Chart from 'chart-js/index.js.erb';
document.addEventListener("turbolinks:load", () => {
  I18n.defaultLocale = "fr";
  I18n.locale = $('#locale').data()['locale'];

  "use strict"; // Start of use strict
  if ($('#mentorMentee').length) {

    var mentorMentee = document.getElementById("mentorMentee");
    var sessions = document.getElementById("sessionsPerMonth");

    getMentorMenteeData(mentorMentee);
    getSessionsData(sessions);

    function getMentorMenteeData(mentorMentee) {
      $.ajax(mentorMentee.dataset.source, {
          type: 'GET',
          success: function (data, status, xhr) {
              drawMentorMentee(mentorMentee, data)
          },
          error: function (jqXhr, textStatus, errorMessage) {
              // TODO
          }
      });
    }

    function getSessionsData(sessions) {
    $.ajax(sessions.dataset.source, {
        type: 'GET',
        success: function (data, status, xhr) {
          drawSessions(sessions, data)
        },
        error: function (jqXhr, textStatus, errorMessage) {
          // TODO
        }
      });
    }

    function drawMentorMentee(mentorMentee, data) {
      new Chart(mentorMentee, {
        type: 'doughnut',
        data: {
          labels: ["Mentors", I18n.t("js.program_dashboard.mentees")],
          datasets: [{
            data: data,
            backgroundColor: ['#4e73df', '#1cc88a'],
            hoverBackgroundColor: ['#2e59d9', '#17a673'],
            hoverBorderColor: "rgba(234, 236, 244, 1)",
          }],
        },
        options: {
          maintainAspectRatio: false,
          tooltips: {
            backgroundColor: "rgb(255,255,255)",
            bodyFontColor: "#858796",
            borderColor: '#dddfeb',
            borderWidth: 1,
            xPadding: 15,
            yPadding: 15,
            displayColors: false,
            caretPadding: 10,
          },
          legend: {
            display: false
          },
          cutoutPercentage: 80,
        },
      });
    }

    function drawSessions(sessions, data) {
      new Chart(sessions, {
        type: "bar",
        data: {
          labels: data["labels"],
          datasets: [{
            label: "Sessions",
            backgroundColor: ["rgba(78, 115, 223, 1)"],
            borderColor: "rgba(78, 115, 223, 1)",
            pointRadius: 3,
            pointBackgroundColor: "rgba(78, 115, 223, 1)",
            pointBorderColor: "rgba(78, 115, 223, 1)",
            pointHoverRadius: 3,
            pointHoverBackgroundColor: "rgba(78, 115, 223, 1)",
            pointHoverBorderColor: "rgba(78, 115, 223, 1)",
            pointHitRadius: 10,
            pointBorderWidth: 2,
            data: data["data"],
          }],
        },
        options: {
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 10,
              right: 25,
              top: 25,
              bottom: 0
            }
          },
          scales: {
            xAxes: [{
              time: {
                unit: 'date'
              },
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: {
                maxTicksLimit: 7
              }
            }],
            yAxes: [{
              ticks: {
                maxTicksLimit: 5,
                padding: 10,
                beginAtZero: true,
                callback: function(value) {if (value % 1 === 0) {return value;}}
              },
              gridLines: {
                color: "rgb(234, 236, 244)",
                zeroLineColor: "rgb(234, 236, 244)",
                drawBorder: false,
                borderDash: [2],
                zeroLineBorderDash: [2]
              }
            }],
          },
          legend: {
            display: false
          },
          tooltips: {
            backgroundColor: "rgb(255,255,255)",
            bodyFontColor: "#858796",
            titleMarginBottom: 10,
            titleFontColor: '#6e707e',
            titleFontSize: 14,
            borderColor: '#dddfeb',
            borderWidth: 1,
            xPadding: 15,
            yPadding: 15,
            displayColors: false,
            intersect: false,
            mode: 'index',
            caretPadding: 10,
            callbacks: {
              label: function(tooltipItem, chart) {
                var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                return datasetLabel + number_format(tooltipItem.yLabel);
              }
            }
          }
        }
      });
    }
  }
})
